export const cardsBlogs = [
    {
        title: 'Windows Cleaning',
        text: 'Structural concrete repairs. Precision and safety.',
        img: '/assets/imgs/about/cardsSlider/1.jpg',
        ref: "#1",
        category: 'Most Recent'
    },
    {
        title: 'Caulking & Sealant Renewal',
        text: 'High-Rise & Mid-Rise.',
        img: '/assets/imgs/about/cardsSlider/2.jpg',
        ref: "#2",
        category: 'Renewals'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
    {
        title: 'Commercial Painting',
        text: 'Apartment & Warehouse.',
        img: '/assets/imgs/about/cardsSlider/3.jpg',
        ref: "#3",
        category: 'Technique'
    },
];

export const allCategoriesBlog = [
    'All',
    'Most Recent',
    'Renewals',
    'Technique',
    'Restoration',
    'Innovation',
    'Tips and Learning'
];